import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  TableSelectRow,
  Button
} from 'carbon-components-react';

const WebhookHistoryTableRows: React.FC<any> = ({
  row,
  getRowProps,
  getSelectionProps,
  handleViewDetail
}: any) => {
  const [selected, setSelected] = useState<boolean>(false);
  const handleOnMouseEnter = () => setSelected(true);
  const handleOnMouseLeave = () => setSelected(false);

  return (
    <TableRow
      {...getRowProps({ row })}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <TableSelectRow {...getSelectionProps({ row })} />
      <TableCell
        key={'eventType'}
        className={row.cells[3].value !== 'Delivered' ? 'highlight-row' : ''}
      >
        {row.cells[0].value}
      </TableCell>
      <TableCell
        key={row.cells[1].id}
        className={row.cells[3].value !== 'Delivered' ? 'highlight-row' : ''}
      >
        {row.cells[1].value}
      </TableCell>
      <TableCell
        key={row.cells[2].id}
        className={row.cells[3].value !== 'Delivered' ? 'highlight-row' : ''}
      >
        <div key={'sysId'}>SYS-ID: {row.cells[2].value[0]}</div>
        {row.cells[0].value === 'enquiry:create' && (
          <div key={'jobNo'}>Job: {row.cells[2].value[1]}</div>
        )}
        {(row.cells[0].value === 'referral:create' ||
          row.cells[0].value === 'response:create' ||
          row.cells[0].value === 'referral:update') && (
          <div key={'refNo'}>Ref: {row.cells[2].value[2]}</div>
        )}
        {(row.cells[0].value === 'user:update' ||
          row.cells[0].value === 'user:create') && (
          <div key={'email'}>Email: {row.cells[2].value[3]}</div>
        )}
      </TableCell>
      <TableCell
        key={row.cells[3].id}
        className={row.cells[3].value !== 'Delivered' ? 'highlight-row' : ''}
      >
        {row.cells[3].value}
      </TableCell>
      <TableCell
        key={row.cells[4].id}
        className={row.cells[3].value !== 'Delivered' ? 'highlight-row' : ''}
      >
        {row.cells[4].value}
      </TableCell>
      <TableCell key={'details'} className="bx--table-column-menu">
        {selected && (
          <Button
            kind="ghost"
            className="row-edit-btn"
            onClick={() =>
              handleViewDetail(row.id, row.cells[5].value, row.cells[0].value)
            }
          >
            Details
          </Button>
        )}
      </TableCell>
      <TableCell></TableCell>
    </TableRow>
  );
};

WebhookHistoryTableRows.displayName = 'WebhookHistoryTableRows';
export default WebhookHistoryTableRows;
